import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import DomainCanonical from "@/components/DomainCanonical";
import Landing from "@/pages/Landing";
import Valuation from "@/pages/Valuation";
import Result from "@/pages/Result";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <DomainCanonical />
        <SmoothScroll>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/valuation" element={<Valuation />} />
            <Route path="/result" element={<Result />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </SmoothScroll>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
